// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";
import {useState} from "react";

// Mui Imports
import DoNotTouchIcon from "@mui/icons-material/DoNotTouch";
import FlagIcon from "@mui/icons-material/Flag";
import Brightness1Icon from "@mui/icons-material/Brightness1";
import Divider from "@mui/material/Divider";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import IconButton from "@mui/material/IconButton";
import UndoIcon from '@mui/icons-material/Undo';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import EmojiFlagsIcon from '@mui/icons-material/EmojiFlags';
import PanToolIcon from '@mui/icons-material/PanTool';
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {Avatar, ListItemIcon, ListItemText, Tooltip} from "@mui/material";
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import ThumbUpIcon from "@mui/icons-material/ThumbUp";

// App Imports


import {changeContract} from "./contractSlice";
import {updateAbstractStatus} from "./ContractClient";


// main function
export default function AbstractStatusMenu({ rowContractData }) {


    // ****************** BEGIN STATES ****************************

    const [anchorEl, setAnchorEl] = React.useState(null);
    // const [cdpList, setCdpList] = useState(props.selectedCdps);
    const [owedStatus, setOwedStatus] = useState(null);

    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorContractDataPointId = useSelector((state) => state.rowSelectSlc.value.cdpList);
    const selectorStatus = useSelector((state) => state.rowSelectSlc.value.status);
    const selectorContractSectionId = useSelector((state) => state.contractDataPointSlc.value.contractSectionId);
    const selectorDataType = useSelector((state) => state.contractDataPointSlc.value.dataType);
    const selectorCdpvCount = useSelector((state) => state.contractDataPointValueSlc.value.cdpvCount);
    const selectorContractId = useSelector((state) => state.contractSlc.value.id);

    // ********************** END STORE ********************************


    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************


    // ***************** BEGIN CONTROLS ***************************

    // const cdpList = props.selectedCdps;
    // https://www.geeksforgeeks.org/how-to-correctly-use-axios-params-with-arrays-in-javascript/
    // const URLString = selectorContractDataPointId.map((value, index) => `arr[${index}]=${value}`).join('&');


    const handleCrudMenuOpen = (event) => {
        console.log("this should be the index");
        console.log("rowContractData");
        console.log(rowContractData);
        // console.log(event.currentTarget.index);
        setAnchorEl(event.currentTarget);
    };


    const handleMenuClose = () => {
        setAnchorEl(null);
        // handleMobileMenuClose();
        // handleMainMenuClose();
    };


    const handleApprove = () => {
        handleMenuClose();
        updateAbstractStatus(selectorContractId, 'Approved')
            .then(() => {
                dispatchData(changeContract({cGridRefresh: true}));
            });
    };

    // const handleFinalize = () => {
    //     updateAbstractStatus(selectorContractId, 'Finalized')
    // .then(() => {
    //         dispatchData(changeContract({ workQueueFinalize: true}));
    //         handleMenuClose()
    //     });
    // };

    const handleFinalize = () => {
        handleMenuClose();
        dispatchData(changeContract({ workQueueFinalize: true}));
    };

    const handleUnapprove = () => {
        handleMenuClose();
        updateAbstractStatus(selectorContractId, 'Unapproved')
            .then(() => {
                dispatchData(changeContract({cGridRefresh: true}));
            });
    };

    const handleHold = () => {
        handleMenuClose();
        updateAbstractStatus(selectorContractId, 'On Hold')
            .then(() => {
                dispatchData(changeContract({cGridRefresh: true}));
            });
    };

    const handleRemoveHold = () => {
        handleMenuClose();
        updateAbstractStatus(selectorContractId, 'Unapproved')
            .then(() => {
                dispatchData(changeContract({cGridRefresh: true}));
            });
    };

    const handleTag = () => {
        handleMenuClose();
        updateAbstractStatus(selectorContractId, 'Tagged')
            .then(() => {
                dispatchData(changeContract({cGridRefresh: true}));
            });
    };

    const handleRemoveTag = () => {
        handleMenuClose();
        updateAbstractStatus(selectorContractId, 'Unapproved')
            .then(() => {
                dispatchData(changeContract({cGridRefresh: true}));
            });
    };

    const handleDefer = () => {
        handleMenuClose();
        updateAbstractStatus(selectorContractId, 'Deferred')
            .then(() => {
                dispatchData(changeContract({cGridRefresh: true}));
            });
    };

    const handleReject = () => {
        handleMenuClose();
        updateAbstractStatus(selectorContractId, 'Rejected')
            .then(() => {
                dispatchData(changeContract({cGridRefresh: true}));
            });
    };

    // *************** END CONTROLS *******************************


    // ***************** BEGIN MENU ***************************

    const isMenuOpen = Boolean(anchorEl);

    const crudId = 'primary-search-account-menu';

    const renderMenu = (

        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            id={crudId}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={isMenuOpen}
            onClose={handleMenuClose}
        >
            <MenuItem sx={{ justifyContent: 'center', cursor: 'default'  }}>
                <ListItemText primary="Change Status" sx={{ textAlign: 'center' }} />
            </MenuItem>
            <Divider/>
            {/*<MenuItem onClick={handleAdd}>*/}
            {/*    <ListItemIcon>*/}
            {/*        <AddCircleOutlineIcon fontSize="small" />*/}
            {/*    </ListItemIcon>*/}
            {/*    <ListItemText>Add</ListItemText>*/}
            {/*</MenuItem>*/}
            {/*{(rowContractData.mcode === "Series" || rowContractData.mcode === "Season" || rowContractData.mcode === "Residuals" || rowContractData.mcode === "Participations"*/}
            {/*        || (rowContractData.mcode === "Property"  && rowContractData.groupedStatus === "Finalized") ||*/}
            {/*        (rowContractData.mcode === "Labor Group" && rowContractData.groupedStatus === "Finalized")) &&*/}
                <MenuItem onClick={handleApprove}>
                    <ListItemIcon>
                        <ThumbUpIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Approve</ListItemText>
                </MenuItem>
            {/* }*/}

            {/*{(rowContractData.mcode === "Series" || rowContractData.mcode === "Season" || rowContractData.mcode === "Residuals" || rowContractData.mcode === "Participations"*/}
            {/*        || rowContractData.mcode === "Property" ||*/}
            {/*        (rowContractData.mcode === "Labor Group" && (rowContractData.groupedStatus === "Approved" || rowContractData.groupedStatus === "Finalized"))) &&*/}
                <MenuItem onClick={handleUnapprove}>
                    <ListItemIcon>
                        <UndoIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Unapprove</ListItemText>
                </MenuItem>
             {/*}*/}

            {/*{(*/}
            {/*        // rowContractData.mcode === "Series" || rowContractData.mcode === "Season" || rowContractData.mcode === "Residuals" || rowContractData.mcode === "Participations"*/}
            {/*        //     || rowContractData.mcode === "Property" ||*/}
            {/*        ((rowContractData.mcode === "Labor Group"  || rowContractData.mcode === "Residuals" || rowContractData.mcode === "Property" ) && rowContractData.status === "u")) &&*/}
                <MenuItem onClick={handleFinalize}>
                    <ListItemIcon>
                        <DoneOutlineIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Finalize</ListItemText>
                </MenuItem>
             {/*}*/}
            {/*{(rowContractData.mcode === "Series" || rowContractData.mcode === "Season" || rowContractData.mcode === "Residuals"*/}
            {/*        || rowContractData.mcode === "Property" || rowContractData.mcode === "Labor Group" ||*/}
            {/*        (rowContractData.mcode === "Guild" && rowContractData.contractStatus !== "On Hold")) &&*/}
                <MenuItem onClick={handleHold}>
                    <ListItemIcon>
                        <PanToolIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Hold</ListItemText>
                </MenuItem>
             {/*}*/}

            {/*{(rowContractData.mcode === "Series" || rowContractData.mcode === "Season" || rowContractData.mcode === "Residuals"*/}
            {/*        || rowContractData.mcode === "Property" || rowContractData.mcode === "Labor Group" ||*/}
            {/*        (rowContractData.mcode === "Guild" && rowContractData.contractStatus === "On Hold")) &&*/}
                <MenuItem onClick={handleRemoveHold}>
                    <ListItemIcon>
                        <DoNotTouchIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Remove Hold</ListItemText>
                </MenuItem>
             {/*}*/}

            {/*{(rowContractData.mcode === "Series" || rowContractData.mcode === "Season" || rowContractData.mcode === "Residuals"*/}
            {/*        || rowContractData.mcode === "Property" || rowContractData.mcode === "Labor Group" ||*/}
            {/*        (rowContractData.mcode === "Guild" && rowContractData.contractStatus !== "Tagged")) &&*/}
                <MenuItem onClick={handleTag}>
                    <ListItemIcon>
                        <BookmarkIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Tag</ListItemText>
                </MenuItem>
             {/*}*/}

            {/*{(rowContractData.mcode === "Series" || rowContractData.mcode === "Season" || rowContractData.mcode === "Residuals"*/}
            {/*        || rowContractData.mcode === "Property" || rowContractData.mcode === "Labor Group" ||*/}
            {/*        (rowContractData.mcode === "Guild" && rowContractData.contractStatus === "Tagged")) &&*/}
                <MenuItem onClick={handleRemoveTag}>
                    <ListItemIcon>
                        <BookmarkBorderIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Remove Tag</ListItemText>
                </MenuItem>
             {/*}*/}

            {/*{(rowContractData.mcode === "Guild" && rowContractData.contractStatus !== "Rejected" && rowContractData.contractStatus !== "Approved") &&*/}
                <MenuItem onClick={handleReject}>
                    <ListItemIcon>
                        <ThumbDownIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Reject</ListItemText>
                </MenuItem>
             {/*}*/}

            {/*{(rowContractData.mcode === "Guild" && rowContractData.contractStatus !== "Deferred" && rowContractData.contractStatus !== "Approved") &&*/}
                <MenuItem onClick={handleDefer}>
                    <ListItemIcon>
                        <QuestionMarkIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Defer</ListItemText>
                </MenuItem>
             {/*}*/}
        </Menu>
    );

    // ***************** END MENU ***************************


    // ***************** BEGIN AVATAR ***************************

    const getAvatar = (rowContractData) => {

        // if (rowContractData.mcode === 'Property') {
        // return (
        //     <Tooltip title="Generated">
        //         <Avatar sx={{ height: 20, width: 20, fontSize: 14, color: 'black', bgcolor: 'white' }}>u</Avatar>
        //     </Tooltip>
        // );}

        // if ( rowContractData.mcode === ''
        //     // || rowContractData.mcode === 'Season' || rowContractData.mcode === 'Series'
        // ) {
        //     // if (rowContractData.mcode === 'Residuals' || rowContractData.mcode === ''
        //     //     || rowContractData.mcode === 'Season' || rowContractData.mcode === 'Series') {
        //     return (
        //         <div>
        //             {/*<ContractGridStatusApprovedMenu/>*/}
        //         </div>)}

        // if (rowContractData.status === 'Approved' && rowContractData.mcode === 'Guild') {
        if (rowContractData.status === 'Approved') {
            return (
                <div>
                    <Avatar sx={{height: 20, width: 20, fontSize: 14, bgcolor: 'rgb(30,144,255)'}}>a
                    </Avatar>
                </div>)}

        // if (rowContractData.status === 'NEW') {
        //     return (
        //         <div>
        //             <Avatar sx={{height: 20, width: 20, fontSize: 14, bgcolor: '#424242'}}>s
        //             </Avatar>
        //         </div>)}
        if ((rowContractData.status === 'NEW' || rowContractData.status === 'Unapproved' )  && rowContractData.missingInputCount < 1 ) {
            // if ((rowContractData.status === 'Unapproved' || rowContractData.status === 'NEW')  && rowContractData.mcode === 'Guild'  && rowContractData.missingInputCount === 0 ) {
            return (
                <div>
                    <Avatar sx={{height: 20, width: 20, fontSize: 14, bgcolor: 'rgb(0,128,0)'
                        // bgcolor: '#1b5e20'
                    }}>u
                    </Avatar>
                </div>)}
        if (rowContractData.status === 'NEW'  && rowContractData.missingInputCount > 0 ) {
            // if ((rowContractData.status === 'Unapproved' || rowContractData.status === 'NEW')  && rowContractData.mcode === 'Guild'  && rowContractData.missingInputCount > 0 ) {
            return (
                <div>
                    <Avatar sx={{height: 20, width: 20, fontSize: 14, bgcolor: '#d50000'}}>{rowContractData.missingInputCount}
                    </Avatar>
                </div>)}
        // if (rowContractData.status === 'u'  && rowContractData.missingInputCount === 0 ) {
        //     // if ((rowContractData.status === 'Unapproved' || rowContractData.status === 'NEW')  && rowContractData.mcode === 'Guild'  && rowContractData.missingInputCount === 0 ) {
        //     return (
        //         <div>
        //             <Avatar sx={{height: 20, width: 20, fontSize: 14, bgcolor: 'rgb(0,128,0)'}}>u
        //             </Avatar>
        //         </div>)}
        // if (rowContractData.status === 'u'  && rowContractData.missingInputCount > 0 ) {
        //     // if ((rowContractData.status === 'Unapproved' || rowContractData.status === 'NEW')  && rowContractData.mcode === 'Guild'  && rowContractData.missingInputCount > 0 ) {
        //     return (
        //         <div>
        //             <Avatar sx={{height: 20, width: 20, fontSize: 14, bgcolor: '#d50000'}}>u
        //             </Avatar>
        //         </div>)}
        //
        // if (rowContractData.status === 'Rejected' && rowContractData.mcode === 'Guild') {
        //     return (
        //         <div>
        //             <Avatar sx={{height: 20, width: 20, fontSize: 14, bgcolor: '#424242'}}>r
        //             </Avatar>
        //         </div>)}
        // if (rowContractData.status === 'Deferred' && rowContractData.mcode === 'Guild') {
        //     return (
        //         <div>
        //             <Avatar sx={{height: 20, width: 20, fontSize: 14, bgcolor: '#424242'}}>d
        //             </Avatar>
        //         </div>)}
        // // if (rowContractData.status === 'Flagged' && rowContractData.mcode === 'Guild') {
        // if (rowContractData.status === 'f') {
        //     return (
        //         <div>
        //             <Avatar sx={{height: 20, width: 20, fontSize: 14, bgcolor: '#424242'}}>f
        //             </Avatar>
        //         </div>)}
        // // if (rowContractData.status === 'On Hold' && rowContractData.mcode === 'Guild') {
        // if (rowContractData.status === 'h') {
        //     return (
        //         <div>
        //             <Avatar sx={{height: 20, width: 20, fontSize: 14, bgcolor: '#424242'}}>h
        //             </Avatar>
        //         </div>)}
        // // if ((rowContractData.mcode === 'Option' || rowContractData.mcode === 'Cast' || rowContractData.mcode === 'Engagement' )
        // if ((rowContractData.status === '' || rowContractData.status === null )
        //     && rowContractData.missingInputCount > 0 && rowContractData.missingInputCount > 0 ) {
        //     return (
        //         <div>
        //             <Avatar sx={{ml: 1.5, height: 20, width: 20, fontSize: 14, bgcolor: '#d50000'}}>{rowContractData.missingInputCount}
        //             </Avatar>
        //         </div>)}
        //
        // if ((rowContractData.status === '' || rowContractData.status === null )
        //     && rowContractData.missingInputCount > 0 && rowContractData.missingInputCount === 0
        //     && rowContractData.mcode === 'Series') {
        //     return (
        //         <div>
        //             <Avatar sx={{
        //                 ml: 1.5,
        //                 height: 20, width: 20, fontSize: 14, color: '#d50000',fontColor: '#d50000',  bgcolor: '#d50000'}}>_</Avatar>
        //         </div>)}
        // if ((rowContractData.status === '' || rowContractData.status === null )
        //     && rowContractData.missingInputCount > 0 && rowContractData.missingInputCount === 0
        //     && rowContractData.mcode !== 'Property' && rowContractData.mcode !== 'Series' && rowContractData.mcode !== 'Season'
        // ) {
        //     return (
        //         <div>
        //             <Avatar sx={{
        //                 // ml: 1.5,
        //                 height: 20, width: 20, fontSize: 14, color: '#d50000',fontColor: '#d50000',  bgcolor: '#d50000'}}>_</Avatar>
        //         </div>)}
        // if ((rowContractData.status === 'm') && (rowContractData.missingInputCount > 0 )
        // ) {
        //     return (
        //         <div>
        //             <Avatar sx={{ml: 1.5,height: 20, width: 20, fontSize: 14, bgcolor: '#d50000'}}>m
        //             </Avatar>
        //         </div>)}
        // if ((rowContractData.status === 'm') && (rowContractData.missingInputCount === 0 || rowContractData.missingInputCount === '' || rowContractData.missingInputCount === null  )
        // ) {
        //     return (
        //         <div >
        //             <Avatar sx={{height: 20, width: 20, fontSize: 14,  bgcolor: 'rgb(0,128,0)'}}>m
        //             </Avatar>
        //         </div>)}



        else{
            return (
                <div >
                    <Avatar sx={{height: 20, width: 20, fontSize: 14, opacity: .1}}> </Avatar>
                </div>
                // <IconButton
                //     size="large"
                //     edge="end"
                //     aria-label="account of current user"
                //     aria-controls={crudId}
                //     aria-haspopup="true"
                //     color="inherit"
                // >
                //     <MoreVertIcon  color="primary" fontSize="small"/>
                // </IconButton>
            );
            // return null;
        }

    };

    // ***************** END AVATAR ***************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <div onClick={handleCrudMenuOpen}>
                {getAvatar(rowContractData)}
            </div>
            {renderMenu}
        </div>
    );

    // ****************** END RETURN ****************************

}